export default [
  {
    name: 'TagList',
    path: '',
    component: () => import('./pages/TagList.vue'),
    meta: {
      title: 'Метки',
      authorize: [],
      help: 60,
    },
  },
];
